import { render, staticRenderFns } from "./coupon-guide.vue?vue&type=template&id=9f4d04a0&scoped=true"
import script from "./coupon-guide.vue?vue&type=script&setup=true&lang=ts"
export * from "./coupon-guide.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./coupon-guide.vue?vue&type=style&index=0&id=9f4d04a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4d04a0",
  null
  
)

export default component.exports